import { Space_Grotesk } from 'next/font/google';
import localFont from 'next/font/local';

export const spaceGrotesk = Space_Grotesk({
  weight: ['400', '500', '700'],
  subsets: ['latin'],
  variable: '--space-grotesk',
});

export const gtWalsheim = localFont({
  src: [
    {
      path: '../../styles/fonts/GTWalsheim-Bold.woff2',
      weight: '700',
    },
    { path: '../../styles/fonts/GTWalsheim-Medium.woff2', weight: '500' },
    { path: '../../styles/fonts/GTWalsheim-Regular.woff2', weight: '400' },
  ],
  variable: '--gt-walsheim',
});

export const mockFonts = [spaceGrotesk, gtWalsheim];
